import { featureItems } from '@/mocks/homeData';

const iconColors: Record<number, string> = {
  1: 'bg-primary-100 text-primary-600',
  2: 'bg-accent-100 text-accent-600',
  3: 'bg-secondary-100 text-secondary-600',
  4: 'bg-primary-100 text-primary-600',
};

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-shield-star-line"></i>
            <span>平台特色</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            糖心视频为什么成为数千万用户的首选观影平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-background-200 transition-colors text-center group"
            >
              <div
                className={`w-14 h-14 mx-auto rounded-2xl flex items-center justify-center mb-4 transition-colors ${
                  iconColors[item.id] || 'bg-primary-100 text-primary-600'
                }`}
              >
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}